<template>
  <div>
    <div class="page-header"><h2>Trademarked SME Events</h2></div>
    <section class="page-content">
      <!-- individual elements card -->
      <div v-for="p in programs" :key="p.id" class="card">
        <!-- card head -->
        <div class="card-head">
          <h3 style="margin: .5rem 0">{{ p.title }}</h3>
          <button v-if="!p.clicked" @click.prevent="p.clicked = !p.clicked">
            See More
          </button>
        </div>
        <!-- card body  -->
        <div class="card-body" v-if="p.clicked">
          <p v-html="p.description"></p>
        </div>
        <!-- card footer  -->
        <div class="card-footer" v-if="p.clicked">
          <button
            class="btn btn-outline-dark"
            @click.prevent="p.clicked = !p.clicked"
          >
            Hide info
          </button>
        </div>
      </div>
    </section>
    <!-- use map array modifier to select only titles -->
    <ServiceForm
      :options-list="programs.map(p => p.title)"
      id="form"
    ></ServiceForm>
  </div>
</template>

<style scoped>
/* .page-content */
.page-content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
}
div.card {
  grid-column: span 1;
  border-radius: 1rem;
  box-shadow: 2px 8px 30px lightgrey;
}
.card-head {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom-style: solid;
  border-bottom: 1px;
  padding: 1rem;
}
.card-head button {
  background-color: rgba(0, 0, 0, 0);
  color: var(--tetiary-color);
  border-width: 0;
}
.card-body {
  border-width: 2px 0;
  padding: 1rem;
}
.card-footer {
  background-color: var(--secondary-color);
  padding: 0.5rem 0;
  padding: 1rem;
}
@media only screen and (max-width: 998px) {
  div.card {
    grid-column: span 2;
  }
}
</style>

<script>
import ServiceForm from "./ServiceForm.vue";

export default {
  components: {
    ServiceForm
  },
  data() {
    return {
      programs: [
        {
          title: "Business Funding And Acceleration Summit (BFASNG)",
          description:
            "Many MSMEs face the five major needs of <b>Funding; Mentorship; Business Promotions; Business Support; and Collaborations,</b> the BFASNG was ideated as an intentional approach towards supporting innovative and disruptive ideas driven by MSMEs and social enterprises with VALIDATED PRODUCTS/SERVICES (Early Startup, Growth and Matured companies). The BFASNG helps them solve these five needs on an annual basis by giving  opportunity to meet with experts under one roof in order to firm up strategic partnerships that will help them succeed. In the maiden edition, we collaborated with Manufacturers Association of Nigeria Resource Center to organize the BFASNG and we are ready to collaborate with you in organizing subsequent editions. To view previous editions of BFASNG, search with hash tag #BFASNG, to partner or collaborate with us please fill the form below and our team member will call you.",
          clicked: false
        },
        {
          title: "Manufacturers Distribution And Supply Chain Summit (MDSSNG)",
          description:
            "From research, manufacturers incur huge overhead cost in order to get their raw materials to their factories, expand their market reach and take their products down to the final consumers. It is saddening that in addition to other overheads, this marketing and logistics costs contribute more than 30% of the expenditure of an average manufacturer. In order to help address this challenge and position Nigerian manufacturers well to compete with their African counterparts especially at this time when we have the African Continental Free Trade Agreement (AfCFTA), the MDSSNG was ideated. In the maiden edition, we collaborated with Manufacturers Association of Nigeria Resource Center to organize the MDSSNG and we are ready to collaborate with you in organizing subsequent editions. To view previous editions of MDSSNG, search with hash tag <b>#MDSSNG</b>, to partner or collaborate with us please fill the form below and our team member will call you.",
          clicked: false
        }
      ],
      clicked: false
    };
  }
};
</script>
